module.exports = __webpack_public_path__ + "img/cercania.b306d613.svg";